import { createReducer, on } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { ListarEdicoesParaCalendarioOutputDto } from "src/app/domain/DTOs/output/jornal/listar-edicoes-para-calendario-output.dto";
import { listarEdicoesCalendario, listarEdicoesCalendarioFinish, listarEdicoesCalendarioSuccess } from "../../actions/Jornal/listar-edicoes-para-calendario.action";

export interface listarEdicoesCalendarioState {
    response: EstruturaRetornoDadosOutputDto<ListarEdicoesParaCalendarioOutputDto[]> | null;
    error: string[] | null;
}

export const initialState: listarEdicoesCalendarioState = {
    response: null,
    error: null,
};

export const listarEdicoesCalendarioReducer = createReducer(
    initialState,
    on(listarEdicoesCalendario, state => ({ ...state, error: null })),
    on(listarEdicoesCalendarioSuccess, (state, { response }) => ({ ...state, response, error: null })),
    on(listarEdicoesCalendarioFinish, state => ({ ...state, response: null, error: null }))
);
